import { mergeStyleSets } from '@uifabric/merge-styles';
import theme, { layout } from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    width: '100%',
    padding: 0,
    paddingTop: 100,
    zoom: '75%',
    fontWeight: 300,
    // reduce by the height of the command bar as it's not on this page
    marginTop: `-${pxToRem(3 * layout.constants.commandBar.height)}`,
  },
  mobile: {
    marginTop: 0,
  },
  hero: {
    position: 0,
    paddingTop: 100,
    paddingLeft: '10%',
    background: 'url("/images/hero-img.png") no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: 699,
  },
  heroHeader: {
    width: 472,
    height: 137,
    marginBottom: '2em',
    selectors: {
      '& span': {
        fontSize: 58,
        fontWeight: 300,
        letterSpacing: 0.1,
        lineHeight: 60,
        color: theme.palette.white,
      },
    },
  },
  heroDetails: {
    width: 574,
    height: 180,
    fontSize: '1.7rem',
    fontWeight: 300,
    textAlign: 'left',
    lineHeight: 35,
    color: theme.palette.white,
    marginBottom: '2em',
  },
  logoutButton: {
    zoom: '200%',
  },
  aboutRoyalties: {
    fontSize: '1.4rem',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  aboutRoyaltiesHeadline: {
    margin: '1.3em 20% 1.3em 20%',
    lineHeight: '1.2em',
    textAlign: 'center',
    fontSize: '3rem',
  },
  contactButton: {
    zoom: '200%',
    maxWidth: '100% !important',
    selectors: {
      '& .ms-Button-label': {
        color: theme.palette.neutralLighter,
      },
    },
  },
  loginText: {
    color: `${theme.palette.neutralDark} !important`,
  },
  buttonMargin: {
    marginBottom: '16px',
  },
});
